module.exports = __webpack_public_path__ + "img/ic_temperature.7e83a3eb.png";